<template>
    <footer class="footer">
    </footer>
</template>

<script>
    export default {
        name: 'Footer',
        components: {
        },
        data:function(){
            return {
            }
        },
        methods:{
        },
    }
</script>


<style scoped>
</style>
